import { STTypo, STTypoModels } from '@protector/components';
import { COLOR_OPTIONS } from 'config/style';
import styles from './display-trap-name-id.module.css';

interface DisplayTrapNameIdProps {
  trapName: string;
  trapId: string;
}

export const DisplayTrapNameId = ({ trapName, trapId }: DisplayTrapNameIdProps) => {
  const trapIdLabel = `ID: ${trapId}`;

  return (
    <div className={styles.container}>
      <span className={styles.truncated} title={trapName}>
        <STTypo type={STTypoModels.TypeOptions.P1} fontFamily='Noto Sans' color={COLOR_OPTIONS.NEUTRAL_100}>
          {trapName}
        </STTypo>
      </span>
      <span className={styles.truncated} title={trapIdLabel}>
        <STTypo type={STTypoModels.TypeOptions.P2} fontFamily='Noto Sans' color={COLOR_OPTIONS.NEUTRAL_60}>
          {trapIdLabel}
        </STTypo>
      </span>
    </div>
  );
};
